import { render, staticRenderFns } from "./ImageTextView.vue?vue&type=template&id=5beb7e4c&scoped=true"
import script from "./ImageTextView.vue?vue&type=script&lang=js"
export * from "./ImageTextView.vue?vue&type=script&lang=js"
import style0 from "./ImageTextView.vue?vue&type=style&index=0&id=5beb7e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb7e4c",
  null
  
)

export default component.exports